module.exports = __webpack_public_path__ + "static-appopensalud/img/logo-menttum-grande.864e805.png";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/logo-menttum-grande.png
// module id = 1048
// module chunks = 120